module.exports = __webpack_public_path__ + "static/media/add-close-ppl.cf84c274.svg";